<template>
  <div class="addressList">
    <!--新增收货地址-->
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="addAddressShow" position="bottom" :style="{ height: '100%' }">
      <div class="addAddress_pop">
        <div class="addAddress_pop_main">
          <van-field v-model="addAddress.name" label="联系人" placeholder="您的姓名" />
          <van-field
            v-model="addAddress.tel"
            type="tel"
            maxlength="11"
            label="联系电话"
            placeholder="您的手机"
            :formatter="formatter"
          />
          <van-field
            v-model="addAddress.areaName"
            label="配送区域"
            placeholder="点击选择配送区域"
            readonly
            @click="addAreaShow = true"
          />
          <van-field v-model="addAddress.addr" label="详细地址" placeholder="请填写您的详细地址" />
          <van-cell center title="默认地址">
            <template #right-icon>
              <van-switch
                @change="switchChange"
                v-model="addAddress.isdefault"
                size="20px"
                active-color="#ff0023"
                inactive-color="#ddd"
                :active-value="1"
                :inactive-value="0"
              />
            </template>
          </van-cell>
        </div>
        <div class="addAddress_pop_btn">
          <span class="b_red white bor_red" @click="addressSave">确定</span>
          <span class="bor_ddd b_white gray_3 " @click="callAddrBack">返回</span>
        </div>
      </div>
    </van-popup>
    <!--新增收货地址地区选择-->
    <!--eslint-disable-next-line-->
    <van-popup
      v-model:show="addAreaShow"
      :safe-area-inset-bottom="true"
      closeable
      round
      position="bottom"
    >
      <van-cascader
        v-model="addAddress.areaId"
        title="请选择所在地区"
        :options="options"
        @change="areaChange"
        @finish="areaSelect"
        :field-names="fieldNames"
        @close="addAreaShow = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Toast } from "vant";
import common from "@/assets/js/common";
// import cityData3 from '@/assets/js/city.data-3';

export default {
  data() {
    return {
      deliveryId: null,
      cusboId: "",
      fieldNames: {
        text: "name",
        value: "id",
        children: "children"
      },
      options: [],
      areaIndex: [],
      addAddressShow: true, // 是否显示新增收货地址
      addAreaShow: false, // 是否显示新增收货地址省市区选择
      disabledList: [
        // 超出范围地址
      ],
      addressInfo: {}, // 编辑地址的地址信息
      // areaList: cityData, // 省市县的数据
      areaList: {}, // 省市县的数据
      searchResult: [], // 搜索详细地址联想的地址
      chosenAddressId: this.selectDeliveryId,
      addressList: [],
      nameOrPhone: "",
      addAddress: {
        deliveryId: null,
        name: "",
        tel: "",
        areaId: "",
        addr: "",
        areaName: "",
        isdefault: 0,
        isDefault: 0,
        cusboId: ""
      }
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    if (/(nxin.com)$/.test(window.location.host)) {
      document.domain = "nxin.com";
    }
    if (/(dbn.cn)$/.test(window.location.host)) {
      document.domain = "dbn.cn";
    }
    this.deliveryId = this.$route.query.deliveryId;
    this.cusboId = this.$route.query.cusboId;
    if (this.deliveryId) {
      this.$store.dispatch("addr/addr/editAddr", { deliveryId: this.deliveryId }).then(data => {
        this.addAddress = data.memberDelivery;
        this.addAddress.areaName = data.memberDelivery.areaFullName;
        const isdefault = data.memberDelivery.isDefault;
        this.$set(this.addAddress, "isdefault", isdefault);
      });
    }
    if (this.cusboId !== "") {
      this.addAddress.cusboId = this.cusboId;
    }
    if (!common.isLogin(this.userInfo.id)) {
      return;
    }
    this.getAreas(0, 0);
  },
  methods: {
    formatter(value) {
      // 过滤输入的数字
      return value.replace(/[^\d]/g, "");
    },
    switchChange(e) {
      this.$set(this.addAddress, "isdefault", e);
    },
    // 获取省市县 index 0-省 1-市 2-县 3-街道
    getAreas(areaId, index) {
      this.$store
        .dispatch("app/getAreas", {
          parentId: areaId
        })
        .then(data => {
          const list = data.map(item => {
            const { id, end, name } = item;
            if (end) {
              return { id, end, name };
            }
            return {
              id,
              end,
              name,
              children: []
            };
          });
          if (index === 0) {
            this.options = list;
          } else if (index === 1) {
            this.options.forEach(item => {
              if (item.id === areaId) {
                item.children = list;
              }
            });
          } else if (index === 2) {
            const parentId = this.areaIndex[0];
            this.options.forEach(item => {
              if (item.id === parentId) {
                item.children.forEach(item1 => {
                  if (item1.id === areaId) {
                    item1.children = list;
                  }
                });
              }
            });
          } else if (index === 3) {
            const parentId = this.areaIndex[0];
            const cityId = this.areaIndex[1];
            this.options.forEach(item => {
              if (item.id === parentId) {
                item.children.forEach(item1 => {
                  if (item1.id === cityId) {
                    item1.children.forEach(item2 => {
                      if (item2.id === areaId) {
                        const lastObj = {
                          id: `${areaId}`,
                          name: "暂不选择",
                          end: true
                        };
                        list.push(lastObj);
                        item2.children = list;
                      }
                    });
                  }
                });
              }
            });
          }
        });
    },
    // 选择省市县的change事件
    areaChange(event) {
      console.log("change", event);
      const { value, tabIndex, selectedOptions } = event;
      const { end, children } = selectedOptions[tabIndex];
      if (tabIndex === 0) {
        this.areaIndex = [value, "", ""];
      } else if (tabIndex === 1) {
        const province = this.areaIndex[0];
        this.areaIndex = [province, value, ""];
      } else if (tabIndex === 2) {
        this.areaIndex[2] = value;
      }
      // end 是否结束查询 如果有子级元素结束查询
      if (end || children.length) {
        return;
      }
      const index = tabIndex + 1;
      this.getAreas(value, index);
    },
    // 新增地址确定
    addressSave() {
      const { deliveryId, name, tel, addr, areaId, isdefault, cusboId } = this.addAddress;
      if (!name || !tel || !addr || !areaId) {
        Toast("请补全增加信息");
        return;
      }
      if (tel.length != 11) {
        Toast("联系电话不正确");
        return;
      }
      this.addAddress.isDefault = isdefault;
      const url = "addr/addr/editDelivery";
      this.$store
        .dispatch(
          url,
          this.$qs.stringify({
            cusboId,
            deliveryId,
            ...this.addAddress
          })
        )
        .then(data => {
          if (data.code == "0") {
            Toast({
              message: "添加成功！",
              position: "bottom"
            });
            setTimeout(() => {
              // eslint-disable-next-line no-restricted-globals
              if (self !== top) {
                // eslint-disable-next-line no-restricted-globals
                window.parent.addAddrBack(data.data);
              } else {
                window.window.location.href = `${
                  process.env.VUE_APP_APP
                }mob/member/delivery/deliveryList.do`;
              }
            }, 1500);
          } else {
            Toast({
              message: data.msg,
              position: "bottom"
            });
          }
        });
    },
    areaSelect(item) {
      console.info(item);
      this.addAreaShow = false;
      const areaName = [];
      item.selectedOptions.forEach(area => {
        if (area.name !== "暂不选择") {
          areaName.push(area.name);
        }
      });
      this.$set(this.addAddress, "areaName", areaName.join(""));
    },
    callAddrBack() {
      // eslint-disable-next-line no-restricted-globals
      if (self !== top) {
        if (this.deliveryId) {
          // eslint-disable-next-line no-restricted-globals
          window.parent.addAddrBack(this.addAddress);
        } else {
          // eslint-disable-next-line no-restricted-globals
          window.parent.vm.callAddrBack();
        }
      } else {
        window.location.href = `${process.env.VUE_APP_APP}mob/member/delivery/deliveryList.do`;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
